<!--
 * @Description:
 * @Date: 2021-11-11 18:16:01
-->
<template>
  <el-row type="flex" justify="start" align="middle">
    <el-checkbox
      style="margin-right: 30px"
      :disabled="!tableData.length"
      :value="selectedSize > 0"
      @change="change"
      :indeterminate="indeterminate"
    >
      结果全选
      <span v-if="selectedSize > 500" style="color: red;">
        （最多选择500条）
      </span>
    </el-checkbox>
    <span>
      已选
      <span>{{ selectedSize || 0 }}</span>
      项， 批量操作：
    </span>
    <el-button
      :disabled="!actionEnabled"
      type="primary"
      size="small"
      @click="pass(2)"
    >
      批量通过
    </el-button>
    <el-button
      :disabled="!actionEnabled"
      type="primary"
      size="small"
      plain=""
      @click="pass(3)"
    >
      批量驳回
    </el-button>
  </el-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import request from '@/tools/request';
import noPass from '@/page/project-record/services/audit-no-pass.js';
import Vue from 'vue';
import { quickAudit } from '../../api';

export default {
  name: 'task-record-batch-action',
  computed: {
    ...mapState('dataAnalysis/task', [
      'tableData',
      'pageTotal',
      'selectedSize',
      'isAll',
      'maxSelectedSize'
    ]),
    // ...mapState('dataAnalysis', ['projectDetail']),
    actionEnabled() {
      return this.selectedSize > 0;
    },
    indeterminate() {
      return this.selectedSize > 0 && this.selectedSize < this.maxSelectedSize;
    }
  },
  methods: {
    change() {
      let isSelected = this.selectedSize > 0 ? false : true;
      isSelected = this.indeterminate ? true : isSelected;
      this.selectAll(isSelected).then(res => {
        const { list, total, query } = res;
        this.$parent.tableData = list;
        this.$parent.tableTotal = total;

        setTimeout(() => {
          for (const k in query) {
            this.$parent.$refs.baseForm.form[k] = query[k];
          }
        });
      });
    },
    ...mapActions('dataAnalysis/task', ['selectAll', 'batchAudit']),
    //是否评率过快
    async isFrequencyFast() {
      let countdown = 0; // 倒计时初始值
      let timer = null; // 存储定时器的引用
      let setTime = null;
      let currentTime = Math.ceil(Date.now() / 1000);
      const randomSecond = Math.floor(Math.random() * 21) + 10;
      let lastTime = '';
      let res = await quickAudit.batchAuditCountDown();
      lastTime = Math.ceil(res.data.data / 1000);
      let intervalTime = currentTime - lastTime; //间隔时间
      let selcetTime = this.selectedSize;
      if (intervalTime < selcetTime) {
        countdown = selcetTime - intervalTime;
        if (this.selectedSize >= 500) {
          countdown = countdown + randomSecond;
        }
      } else {
        countdown = null;
      }
      if (countdown && countdown > 0) {
        //计算时间
        return new Promise(resolve => {
          this.$confirm(
            `<p>是否确认通过<span style="color:#027cfa">${
              this.selectedSize
            }</span>条任务记录，请谨慎操作</p><p style="font-size:12px;color:red;margin-top:20px"><img style="width:30px;height:30px;margin-top:-16px" src="${require('../../../../assets/img/休息.svg')}" />提示：您的审核频率过快，请保持劳逸结合审核效果才会更高哦！</p>`,
            '',
            {
              confirmButtonText: `确定(${countdown}s)`, // 初始按钮文本
              cancelButtonText: '取消',
              customClass: 'customRateDialog',
              dangerouslyUseHTMLString: true,
              showClose: false,
              closeOnPressEscape: false,
              closeOnClickModal: false
            }
          )
            .then(() => {
              resolve();
              clearInterval(timer);
              clearTimeout(setTime);
              restBtn();
            })
            .catch(() => {
              clearInterval(timer);
              clearTimeout(setTime);
              try {
                const btn = document.querySelector('.daojishi_btn.is-disabled');
                btn.disabled = false;
                btn.classList.remove('is-disabled');
                btn.classList.remove('daojishi_btn');
              } catch (error) {
                console.log(error);
              }
              restBtn();
            });
          let btnWrapper = null;
          setTime = setTimeout(() => {
            btnWrapper = document.querySelector(
              '.customRateDialog .el-message-box__btns .el-button--primary'
            );
            btnWrapper.disabled = true;
            btnWrapper.classList.add('is-disabled');
            btnWrapper.classList.add('daojishi_btn');
          }, 100);
          let startCountdown = () => {
            timer = setInterval(() => {
              let parentElement = document.querySelector(
                '.customRateDialog > .el-message-box__btns'
              ).lastChild;
              let lastSpan = parentElement.querySelector('span');
              lastSpan.innerHTML = `确定(${countdown}s)`;
              if (countdown > 0) {
                countdown--;
              } else {
                lastSpan.innerHTML = '确定';
                clearInterval(timer);
                if (btnWrapper) {
                  btnWrapper.disabled = false;
                  btnWrapper.classList.remove('is-disabled');
                  btnWrapper.classList.remove('daojishi_btn');
                }
              }
            }, 1000);
          };
          startCountdown();
          let restBtn = () => {
            let parentElement = document.querySelector(
              '.customRateDialog > .el-message-box__btns'
            ).lastChild;
            let lastSpan = parentElement.querySelector('span');
            lastSpan.innerHTML = '确定';
            document.querySelector('.customRateDialog').parentNode.remove();
          };
        });
      }
    },
    /**
     *
     * @param type 2：过 3：驳回
     */
    async pass(type) {
      await this.isFrequencyFast();
      if (type === 2) {
        await this.batchAudit(type);
      }
      if (type === 3) {
        const rejectResp = await noPass(this.selectedSize);
        const params = {
          projectId: this.$route.query.id,
          auditStatus: type
        };
        params.remarkType = rejectResp.type;
        params.remark = rejectResp.remark;

        // 展示 loading
        const loading = this.$loading({
          lock: true,
          text: `0 / ${this.selectedSize}`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // 轮询进度
        const queryCountTimer = setInterval(async () => {
          const {
            data: { data }
          } = await request.post(
            '/rest/cso/saas/taskRecord/auditOssStatus/all/queryCount',
            {
              projectId: this.$store.state.dataAnalysis.projectDetail.projectId,
              source: 1 //1任务记录 2 快捷审核
            }
          );
          loading.setText(`${data} / ${this.selectedSize}`);
        }, 500);
        const {
          data: { message }
        } = await request
          .post(
            '/rest/cso/saas/taskRecord/auditOssStatus/all',
            params
            // { serviceLoading: true }
          )
          .finally(() => {
            if (!loading) return;
            loading.setText(`${this.selectedSize} / ${this.selectedSize}`);
            clearInterval(queryCountTimer);
            loading.close();
          });
        this.$message.success(message);
      }
      await this.$parent.tableSearch({ isSelected: '0' });
    }
  }
};
</script>

<style scoped></style>
